import React from 'react';
import '../css/Home.css';
import MeterForm from '../Components/MeterForm';
import { GiCheckedShield } from "react-icons/gi";
import { PiHandCoinsFill } from "react-icons/pi";

const Home = () => {
  return (
    <div className='main section__padding'>
      <div className='main_header'>
        <h1>Welcome to <span className="grosolar">GroSolar</span></h1>
      </div>
      <div className='main_content'>
        <div className='main_text'>
          <p>
            We dedicated to delivering clean and sustainable energy solutions for modern developments. At GroSolar, we recognize that the future 
            of real estate is intertwined with environmental responsibility and energy efficiency. Our team 
            specializes in integrating solar energy solutions across residential, commercial, and mixed-use 
            properties, offering a seamless blend of innovation and sustainability.
            <br />
            <br />
            GroSolar is committed to advancing eco-friendly projects that not only reduce carbon footprints 
            but also contribute to long-term energy savings for our clients. Partner with us as we strive 
            to empower communities with reliable, sustainable energy that paves the way for a greener, 
            brighter future.
          </p>
          <div className="pro">
            <div className="protection">
              <div className="pro1">
                <GiCheckedShield className="icon" />
                <div className="data">
                  <h3>
                    Buyer Protection <br /> <span>100% Guaranteed</span>
                  </h3>
                </div>
              </div>
              <div className="pro2">
                <PiHandCoinsFill className="icon" />
                <div className="data">
                  <h3>
                    Hassle Free Payment <br /> <span>Fast and Convenient</span>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='main_form'>
          <MeterForm />
        </div>
      </div>
    </div>
  );
}

export default Home;
